import { makeStyles } from 'tss-react/mui'

/** Figma 641:3092 / 641:3321 — Schedule Details card in chat. */
export const useStyles = makeStyles()(() => ({
  card: {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: 524,
    backgroundColor: '#f4f7fd',
    border: '1px solid #dde6f0',
    borderRadius: 10,
    padding: '14px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    fontFamily: 'Inter, sans-serif',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    width: '100%',
    paddingBottom: 8,
    borderBottom: '1px solid #dde6f0',
  },
  headerIcon: {
    fontSize: 13,
    lineHeight: '13px',
    color: '#4a6cf7',
  },
  headerTitle: {
    margin: 0,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#2e3132',
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  row: {
    display: 'flex',
    gap: 6,
    alignItems: 'center',
    fontSize: 12,
    lineHeight: '16px',
  },
  label: {
    flexShrink: 0,
    minWidth: 88,
    color: '#2e3132',
    fontWeight: 500,
    letterSpacing: '0.5px',
  },
  value: {
    color: '#2e3132',
    wordBreak: 'break-word',
    minWidth: 0,
  },
  avatarStack: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  avatar: {
    width: 24,
    height: 24,
    borderRadius: 52,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#2e3132',
    flexShrink: 0,
    boxSizing: 'border-box' as const,
    border: '1.5px solid #f4f7fd',
    '&:not(:first-child)': {
      marginLeft: -8,
    },
  },
  avatar0: {
    backgroundColor: '#ffdfc6',
  },
  avatar1: {
    backgroundColor: '#ecd6fd',
  },
  avatarMore: {
    backgroundColor: '#e1e3e3',
    fontSize: 10,
  },
}))
